/* eslint-disable */
import { useState } from 'react';
import { FaBuilding, FaMapMarkerAlt, FaArrowRight, FaChevronDown } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { MdOutlineDeleteSweep } from 'react-icons/md';
import Swal from 'sweetalert2';
import {
  deleteCleaner,
  deleteContractor,
  deleteSpecialAccess,
  deleteUser,
  getAllCleaner,
  getAllContractor,
  getAllSpecialAcess,
  getBnbList,
  getUsers,
  deleteUploads,
  getContractProperties,
} from '../../helper/backend_helper';
import appConfig from 'src/config';

export default function PropertyCard({ data, activeTab, city }) {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const totalProperties = data?.reduce((sum, item) => sum + (item.properties?.length || 0), 0) || 0;

  return (
    <div>
      <div className="max-w-3xl  p-4 bg-white rounded-xl shadow border space-y-4">
        {/* Header */}
        <div className="flex items-center justify-between cursor-pointer">
          <div className="flex items-center space-x-2">
            <FaBuilding className="text-purple-600" />
            <h2 className="text-lg font-semibold">{city}</h2>
          </div>
          <div className="flex items-end space-x-2">
            <div
              onClick={() => setIsOpen(!isOpen)}
              className="cursor-pointer flex items-center space-x-2 text-sm text-gray-500"
            >
              <span>
                {totalProperties} {totalProperties === 1 ? 'property' : 'properties'}
              </span>
              <FaChevronDown className={`transform transition-transform ${isOpen ? 'rotate-180' : 'rotate-0'}`} />
            </div>
          </div>
        </div>

        {/* Collapsible Content */}
        {isOpen && (
          <>
            <div>
              <p className="text-sm font-semibold mb-2">Properties:</p>

              {data?.map((item) =>
                item?.properties.map((property, index) => (
                  <div
                    key={index}
                    onClick={() => navigate('/signed/property_detail', { state: { property, data: item } })}
                    className="flex items-start space-x-4 p-4  rounded-lg border mb-2 hover:bg-gray-100 cursor-pointer"
                  >
                    <img
                      src={
                        property?.mainPhoto
                          ? appConfig.FILE_URL + property?.mainPhoto
                          : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQsMMUke4L3aBu8jImsZhwYBwzFA3z0HOnRgg&s'
                      }
                      alt="img"
                      className="w-20 h-20 object-cover rounded"
                    />
                    <div className="flex-1">
                      <h3 className="text-lg font-semibold">{property.name}</h3>
                      <div className="text-sm text-gray-600 flex items-center space-x-1">
                        <FaMapMarkerAlt className="text-gray-400" />
                        <span>{property.address}</span>
                      </div>
                      <div className="text-sm text-gray-500 mt-1">
                        {property.size} m<sup>2</sup> • Floor {property.floor} • Max guests: {property.manualMaxGuests}
                      </div>
                    </div>
                    <FaArrowRight className="mt-2 text-gray-600" />
                  </div>
                ))
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
